import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import GlobalSearch from 'flarum/forum/components/GlobalSearch';
import MobileTabComponent from '../../common/components/MobileTabComponent';
export default class ForumSearchTabItem extends MobileTabComponent {
  view() {
    const {
      icon,
      label
    } = this.attrs.definition;
    return m(Button, {
      className: "Button Button--link",
      icon: icon,
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/common/components/SearchModal'), {
        searchState: app.search.state,
        sources: GlobalSearch.prototype.sourceItems().toArray()
      })
    }, label);
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/ForumSearchTabItem', ForumSearchTabItem);